"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerInitializer = exports.TrackerUSDInitializer = exports.TrackerInitializationError = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const tracker_1 = require("./tracker");
const TRACKER_ERROR = 'Tracker initialization error';
class TrackerInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(TRACKER_ERROR, message);
    }
}
exports.TrackerInitializationError = TrackerInitializationError;
class TrackerUSDInitializer extends web_ui_framework_1.Initializer {
    //TODOD revisar estos any. Pasa en todas las dependencias de todos los inicializadores
    constructor(config, usdManager, API, authenticator, eventBus) {
        super([eventBus, usdManager, API, authenticator]);
        this.launch = async () => {
            try {
                const trackersToInitialize = [];
                if (this.config.tealiumTracker) {
                    const tealiumTracker = new web_ui_framework_1.TealiumTracker(this.config.tealiumTracker.configData);
                    await (0, tracker_1.addCommonInfoToTealiumTracker)(this.config, tealiumTracker);
                    trackersToInitialize.push(tealiumTracker);
                }
                if (this.config.wrapupTracker) {
                    const wrapupTracker = new web_ui_framework_1.WrapupTracker(this.config.wrapupTracker.configData, this.usdManager.getInitialized().getMethods().registerTrace);
                    await (0, tracker_1.addCommonInfoToWrapupTracker)(this.config, wrapupTracker);
                    trackersToInitialize.push(wrapupTracker);
                }
                const trackerManager = new web_ui_framework_1.TrackerManager(trackersToInitialize);
                return trackerManager;
            }
            catch (e) {
                throw new TrackerInitializationError(e);
            }
        };
        this.config = config;
        this.usdManager = usdManager;
        this.API = API;
        this.authenticator = authenticator;
    }
}
exports.TrackerUSDInitializer = TrackerUSDInitializer;
class TrackerInitializer extends web_ui_framework_1.Initializer {
    constructor(config, API, authenticator, eventBus) {
        super([eventBus, API, authenticator]);
        this.launch = async () => {
            try {
                const trackersToInitialize = [];
                if (this.config.tealiumTracker) {
                    const tealiumTracker = new web_ui_framework_1.TealiumTracker(this.config.tealiumTracker.configData);
                    await (0, tracker_1.addCommonInfoToTealiumTracker)(this.config, tealiumTracker);
                    trackersToInitialize.push(tealiumTracker);
                }
                if (this.config.dynatraceTracker) {
                    const dynatraceTracker = new web_ui_framework_1.DynatraceTracker(this.config.dynatraceTracker.configData, this.config.dynatraceTracker.reporterConfig);
                    await (0, tracker_1.addCommonInfoToDynatraceTracker)(this.config, dynatraceTracker);
                    trackersToInitialize.push(dynatraceTracker);
                }
                const trackerManager = new web_ui_framework_1.TrackerManager(trackersToInitialize);
                return trackerManager;
            }
            catch (e) {
                throw new TrackerInitializationError(e);
            }
        };
        this.config = config;
        this.API = API;
        this.authenticator = authenticator;
    }
}
exports.TrackerInitializer = TrackerInitializer;
//# sourceMappingURL=tracker.initializer.js.map